module.exports = __webpack_public_path__ + "static/media/ios-lock.00c8437a.svg";